import hyperdom from 'hyperdom'
import assetPath from './../assetPath.js'

export default class Footer {
  constructor ({
    config,
    progress,
    year,
    user,
    departure,
    booking,
    brandLogo,
  }) {
    this.config = config
    this.progress = progress
    this.year = year
    this.user = user
    this.departure = departure
    this.booking = booking
    this.brandLogo = brandLogo
  }

  renderFooter (currentTab) {
    return <div class={['page-footer', {'tour-loaded': this.progress.tourLoaded && this.progress.criteriaLoaded}]}>
      <div class='page-footer__left'>
        <a href={this.user.isTravelAgent ? this.config.brandPages.travelAgentHomePage : this.config.brandPages.brandWebsite}>
          <img className='page-nav__logo'
            src={assetPath(`/public/img/brand-logos/${(this.config.isMobile && this.config.mobileFooterLogo) || this.brandLogo}`)}
            alt={this.config.brandName}/>
        </a>
        <div className='page-footer__copyright'>
          © Copyright TTC Travel Group Ltd. {this.year}. All rights reserved
        </div>
      </div>
      {this.renderCurrencyInfo()}
      <div class='page-footer__right'>
        {this.renderCards(currentTab)}
      </div>
      <ul class='page-footer__links'>
        <li class='page-footer__links-item'><a target='_blank' href={this.config.brandPages.termsAndConditions} class='page-footer__link'>Conditions of booking</a></li>
        <li class='page-footer__links-item'><a target='_blank' href={this.config.brandPages.privacyPolicy} class='page-footer__link'>Privacy Policy</a></li>
        {this.config.brandPages.usefulLinks
          ? <li class='page-footer__links-item'><a target='_blank' href={this.config.brandPages.usefulLinks} class='page-footer__link'>Useful links</a></li>
          : undefined
        }
      </ul>
    </div>
  }

  renderCurrencyInfo () {
    return this.progress.tourLoaded
      ? <div class='page-footer__center'>All prices are in  <span style='padding-left: 5px;'>{this.departure.prices.currency}</span></div>
      : undefined
  }

  renderCards (currentTab) {
    if (currentTab && currentTab.id === 'payment') {
      this.supportedCardTypes = this.booking.booking.creditCardTypes.map(cct => cct.toLowerCase())
    } else {
      this.supportedCardTypes = this.config.features.cardPaymentEnabled ? [...this.config.supportedCardTypes] : []
    }
    this.config.features.paypalEnabled && this.supportedCardTypes.push('paypal')
    this.config.features.upliftEnabled && this.supportedCardTypes.push('uplift-usa')
    return <div class="cards-wrapper">
      <div class="u-margin-right-small">{this.config.paymentText}</div>
      <ul class='u-unstyled cards'>
        {this.supportedCardTypes.map(cardName => {
          return <li class='u-inbl card-icon'>
            <img src={assetPath(`/public/img/card-icons/${cardName}.svg`)} alt={cardName} />
          </li>})}
      </ul>
    </div>
  }
}
